/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hero_DescriptionInputs */

const en_directory_hero_description = /** @type {(inputs: Directory_Hero_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare top models in our AI Studio, or browse hundreds of curated tools for your stack. No fluff, just shipping.`)
};

const zh_directory_hero_description = /** @type {(inputs: Directory_Hero_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`别再为了选工具做一堆无效功。我们把分散的 AI 工具与 AIGC 资源归档到明确的场景 / 分类 / 标签，人工审核保持质量。内置模型试玩，先体验后选择。`)
};

/**
* | output |
* | --- |
* | "Compare top models in our AI Studio, or browse hundreds of curated tools for your stack. No fluff, just shipping." |
*
* @param {Directory_Hero_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hero_description = /** @type {((inputs?: Directory_Hero_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hero_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hero_description(inputs)
	return zh_directory_hero_description(inputs)
});
export { directory_hero_description as "directory.hero.description" }